module.exports = __webpack_public_path__ + "static/media/fin-s_icon.f9ec9c07.png";